import React from 'react'
import type { FollowMeProfile } from '@core/Areas/FollowMe/types'
import { IncomingSharedBet, useIncomingSharedBet } from './Components/IncomingSharedBet'
import { PendingBets } from './Components/PendingBets'
import { MyCopiedBets } from './Components/MyCopiedBets'
import { ResultedBets } from './Components/ResultedBets'
import type { TabContentOptions } from '../../types'

export const ProfileBets: React.FC<{
  profile: FollowMeProfile
  setHasCopiedBets(hasBets: boolean): void
  setPendingCount(count: number | null): void
  handleIncomingShareTabChange: (newValue: TabContentOptions) => void
  currentContentDisplay: TabContentOptions
  isUsingScrollRestore: boolean
}> = ({
  profile,
  setHasCopiedBets,
  setPendingCount,
  handleIncomingShareTabChange,
  currentContentDisplay,
  isUsingScrollRestore,
}) => {
  const incomingShare = useIncomingSharedBet({
    currentContentDisplay,
    handleIncomingShareTabChange,
  })

  return (
    <>
      {incomingShare && incomingShare.betOptionTab === currentContentDisplay && (
        <IncomingSharedBet incomingShare={incomingShare} />
      )}

      {currentContentDisplay === 'pending-bets' && (
        <PendingBets
          profileId={profile.id}
          incomingPostId={incomingShare?.sharedBet.postId}
          setPendingBetsCount={setPendingCount}
          isUsingScrollRestore={isUsingScrollRestore}
        />
      )}

      {currentContentDisplay === 'resulted-bets' && (
        <ResultedBets
          profileId={profile.id}
          incomingPostId={incomingShare?.sharedBet.postId}
          isUsingScrollRestore={isUsingScrollRestore}
        />
      )}

      {currentContentDisplay === 'my-copies' && (
        <MyCopiedBets
          setHasCopiedBets={setHasCopiedBets}
          isUsingScrollRestore={isUsingScrollRestore}
        />
      )}
    </>
  )
}
